export const init = () => {
  // TRACKER 'SUGGESTIONS'
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.suggestions.crosssell
  );
  const sep = AnalyticsConstants.separatorST;
  const fwk = CUBE.Analytics;

  const containerCrossSellProduct = '#often-bought-list .plv2-element';

  const getLabel = (element, index) => {
    const model = fwk.utils.productpage.getCrossSellModel(
      element.data('productid'),
      'SM'
    );
    return (
      AnalyticsConstants.slick.defaultValuePosition +
      index +
      sep +
      model.name +
      sep +
      model.id
    );
  };
  const getValue = element => {
    const model = fwk.utils.productpage.getCrossSellModel(
      element[0].closest('[data-productid]').dataset.productid,
      'SM'
    );
    return model.price;
  };

  function getCrossSellLabel(element, selector) {
    let product;
    if (element.hasClass(selector)) {
      product = element;
    } else {
      product = element.closest(selector);
    }
    const index = product.data('index').trim();
    return getLabel(product, index);
  }

  // CrossSell - Move to cart
  // const eventAddToCartCrossSell = new AnalyticsClickEvent(
  //   'virtualEventAddToCartCrossSell',
  //   tracker.defaultEvent()
  // );
  // eventAddToCartCrossSell.options.action = 'AddToCart';
  // eventAddToCartCrossSell.domContainer = '.plv2-element';
  // eventAddToCartCrossSell.domElement = '.cta-v2.dkti-cart';
  // eventAddToCartCrossSell.getLabel = $element =>
  //   getCrossSellLabel($element, '.plv2-element');
  // eventAddToCartCrossSell.getValue = getValue;
  // tracker.addEvent(eventAddToCartCrossSell);

  /*
   * CROSSSELL PRODUCT
   */
  // const eventCrossSellProduct = new AnalyticsClickEvent(
  //   'eventCrosssellSuggestions',
  //   tracker.defaultEvent()
  // );
  // eventCrossSellProduct.options.action = 'PositionClick';
  // eventCrossSellProduct.domContainer = containerCrossSellProduct;
  // eventCrossSellProduct.domElement = '.plv2-el__images a';
  // eventCrossSellProduct.getLabel = function($element) {
  //   return getCrossSellLabel($element, '.plv2-element');
  // };

  // eventCrossSellProduct.getValue = getValue;
  // tracker.addEvent(eventCrossSellProduct);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/commons/suggestions-tracker.js